import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchById as fetchExpFabById } from '../../../features/empresa-estrangeira/empresaEstrangeiraAPI';
import { getLocalidadeOrDefault, isStrictEquals } from '../../../utils/general/general-utils';

const useExportadoresBond = (catalogoProdutoId, handleAddFabricante) => {
  const { t } = useTranslation();

  const formProps = {
    rootName: `ignorableFields.exportadorBond`,
    fields: [
      {
        name: 'exportadorId',
        label: 'Exportador',
      },
      {
        name: 'relacaoExpFab',
        label: 'Exportador é o fabricante?',
        required: false,
      },
    ],
  };

  const listProps = {
    name: 'exportadores',
    columns: [
      {
        field: 'pessoaJuridica.id',
        headerName: t('com.muralis.qcx.codigo'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 80,
        valueGetter: ({ row }) => row?.id,
      },
      {
        field: 'pessoaJuridica.nomeResumido',
        headerName: 'Exportador',
        type: 'string',
        flex: 160,
        valueGetter: ({ row }) => row?.pessoaJuridica?.nomeResumido,
      },
      {
        field: 'endereco.pais.description',
        headerName: t('com.muralis.qcx.endereco.endereco'),
        type: 'string',
        flex: 110,
        valueGetter: ({ row }) => getLocalidadeOrDefault(row?.endereco, '-'),
      },
    ],
  };

  const idToExportadorFabricanteEntity = async (id) => {
    if (!id) return undefined;
    try {
      const response = await fetchExpFabById(id);
      return response?.data;
    } catch (err) {
      return undefined;
    }
  };
  const handleAdd = useCallback(
    async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
      const exp = await idToExportadorFabricanteEntity(currentVinculo?.exportadorId);
      if (!exp) return;

      const updatedVinculos = [...currentVinculos, exp];
      handleSuccessAddVinculo(updatedVinculos);

      if (currentVinculo?.relacaoExpFab === 'SIM') {
        const fabricanteVinculo = {
          fabricanteId: exp.id,
          isConhecido: 'SIM',
          catalogoProduto: { id: catalogoProdutoId },
        };
        handleAddFabricante(fabricanteVinculo, null, null);
      }
    },
    [catalogoProdutoId]
  );
  const handleAlreadyExists = useCallback(
    (currentVinculo, currentVinculosList) =>
      currentVinculosList.some((vinculo) => isStrictEquals(vinculo?.id, currentVinculo?.exportadorId)),
    []
  );

  return {
    formProps,
    listProps,
    handleAdd,
    handleAlreadyExists,
  };
};

export default useExportadoresBond;
